import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast7 extends BCComponent {

    render() {
        return (
            <div>
                <h3>SPECIÁLNÍ – KRITICKÉ MYŠLENÍ</h3>
                <div className='separate-bottom'>
                    <p>Společně s partnery soutěže – Hraj s rozumem a Criticial Thinking Suitcase – jsme pro vás připravili speciální úkoly k rozvoji kritického myšlení.</p>
                    <p><b>Kritické myšlení</b> je důležitou dovedností, která vám pomůže v každodenním životě i ve studiu. Kritické myšlení není jen o tom, co si myslíte, ale také o tom, jak si myslíte.
                    Pojďme se společně podívat, co to znamená být kritickým myslitelem a jak můžeme tuto dovednost rozvíjet.</p>
                    <p>Kritické myšlení je definováno jako <b>„schopnost zkoumat a analyzovat informace a myšlenky s cílem porozumět a hodnotit jejich hodnoty a předpoklady, spíše než jednoduše přijímat návrhy za nominální hodnotu“</b> (UNESCO, 2013). 
                    Kritické myšlení má zásadní vliv na lidské chování: například když je člověk s kritickým myšlením vystaven šokující zprávě, nedělá ukvapené závěry, ani nereaguje tak, že to okamžitě sdělí ostatním. Protože nelze ověřit veškeré informace, hledejte ověření autora a logiku zprávy. Člověk s kritickým myšlením je také schopen posoudit důvody výběru formátu, načasování a způsobu komunikace. Vzhledem k tomu, že média jsou tolik ovlivňována a kontrolována politickou agendou, zůstat kritičtí k informacím, které konzumujeme, nám pomáhá vytvářet si vlastní osobní názory a bránit se pokusům nechat se oklamat pochybnými zdroji.</p>
                    <p><b>Staňte se detektivem – pokládejte správné otázky! </b></p>
                </div>
                <br/>

                { this.showTask('profil_1') }
                
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast7);
